import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ipm-custom-tabs',
  templateUrl: './custom-tabs.component.html',
  styleUrls: ['./custom-tabs.component.scss']
})
export class CustomTabsComponent implements OnInit {

  @Input() headingList: Array<any> = [];
  @Output() updateHeader: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
    
  }

  scrollRight() {
    let container = (document.getElementById('scrollContainer')) as HTMLElement;
    let containerWidth = container.clientWidth;
    container.scrollLeft += containerWidth;
  }

  scrollLeft() {
    let container = (document.getElementById('scrollContainer')) as HTMLElement;
    let containerWidth = container.clientWidth;
    container.scrollLeft -= containerWidth;
  }

  settingTab(btnName:any) {
    this.headingList = this.headingList.filter((item: any) => {
      item.isSelected = item.id === btnName ? true : false;
      if (item.id === btnName) {
        item.isLoadComponent = true
      }
      return item
    });
    this.updateHeader.emit(this.headingList);
  }
}